import React from "react";
import ContactComponent from "../Components/Contact";

const Contact = () => {
  return (
    <main className="py-16 px-6">
      <div className="max-w-4xl mx-auto">
        <ContactComponent />
      </div>
    </main>
  );
};

export default Contact;
